import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApollographqlComponent } from './simple-icons-apollographql.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApollographqlComponent ],
    exports:      [ SimpleIconsApollographqlComponent ],
    bootstrap:    []
})
export class SimpleIconsApollographqlModule {}
